import React, { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { adminApi } from "@/lib/adminApi";

export const SmsWarningBanner = () => {
  const [flags, setFlags] = useState(null);
  useEffect(() => { adminApi.get("/system-flags").then((r) => setFlags(r.data)).catch(() => {}); }, []);
  if (!flags || flags.sms_enabled) return null;
  return (
    <div className="bg-amber-400 text-amber-950 text-sm font-semibold px-6 py-2 flex items-center gap-2" data-testid="sms-disabled-banner">
      <AlertTriangle className="w-4 h-4 shrink-0"/> OTP codes are displayed on screen — not for production use.
    </div>
  );
};

export default SmsWarningBanner;
